 // Get all the elements to be parallaxed
const parallaxElements = document.querySelectorAll('.lax')

//const logo_img = $('.header-logo').attr('src');
const logo_img = document.getElementById("logo");
const logo_filename = logo_img.src.slice(0, -4); // strip extenstion
// The parallax function
const parallax = elements => {
		if ('undefined' !== elements && elements.length > 0) {
			elements.forEach( element => {
				let windowHeight = window.innerHeight;
        let topOffset = element.getBoundingClientRect().top;
        let elementHeight = element.getBoundingClientRect().height
        let y = topOffset + elementHeight;
        // only scroll if it's visible in viewport
				if ( y > 0 && topOffset < windowHeight) {
          var coords = '0% '+ ((0.25 * window.scrollY)) + 'px';
          element.style.backgroundPosition = coords;
				}
			})
		}
	}

//Call the function on scroll
window.onscroll = () => {
		parallax(parallaxElements)

    if (window.scrollY >= 200) {
      document.getElementsByTagName("header")[0].classList.add("bg-primary");
      logo_img.src = logo_filename+'-white.png';

    } else {
      document.getElementsByTagName("header")[0].classList.remove("bg-primary");
      logo_img.src = logo_filename+'.png';
    }
}